import { render, staticRenderFns } from "./TeamsCorrect.vue?vue&type=template&id=ef0dccfc&scoped=true"
import script from "./TeamsCorrect.vue?vue&type=script&lang=js"
export * from "./TeamsCorrect.vue?vue&type=script&lang=js"
import style0 from "./TeamsCorrect.vue?vue&type=style&index=0&id=ef0dccfc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef0dccfc",
  null
  
)

export default component.exports